import { DomainError } from './errors.js';

/**
 * Rolün türü (ADR 0143; ADR 0139 §5): gemi rütbesi (`vessel`), ofis ünvanı (`office`) ya da ikisi
 * de olabilen (`any`). Rütbe kişinin gemi ataması rolüdür (ADR 0071 §1); Sign On ▸ Rank ve
 * Rank change `vessel` + `any`, Ayarlar ▸ Kullanıcılar ▸ şirket rolü `office` + `any` gösterir.
 * Emsal: AMOS ve ShipManager'da rank listesi ile office position listesi ayrıdır.
 */
export const ROLE_KINDS = ['vessel', 'office', 'any'] as const;

export type RoleKind = (typeof ROLE_KINDS)[number];

/** Rolün nerede verildiği: gemi atamasında rütbe (`rank`) ya da şirket rolü (`company`). */
export type RoleUse = 'rank' | 'company';

/** Bilinen tür; değilse `INVALID_ROLE_KIND`. */
export function parseRoleKind(value: unknown): RoleKind {
  if (typeof value === 'string' && (ROLE_KINDS as readonly string[]).includes(value)) {
    return value as RoleKind;
  }
  throw new DomainError('INVALID_ROLE_KIND', String(value));
}

/** Tür bu kullanımda verilebilir mi: rütbe `office` olamaz, şirket rolü `vessel` olamaz. */
export function roleKindAllows(kind: RoleKind, use: RoleUse): boolean {
  return use === 'rank' ? kind !== 'office' : kind !== 'vessel';
}

/**
 * Yeni yazılan rütbe ya da şirket rolünün türü uymuyorsa `ROLE_KIND_MISMATCH`. Yalnız yeni yazmada
 * denetlenir; var olan atamalar bozulmaz (ADR 0143 §3).
 */
export function assertRoleKind(kind: RoleKind, use: RoleUse, name?: string): void {
  if (!roleKindAllows(kind, use)) {
    throw new DomainError('ROLE_KIND_MISMATCH', `${use}: ${name ?? ''} (${kind})`.trim());
  }
}
